import {
    Box,
    Flex,
    Icon,
    Icons,
    Text,
    ThemeBorderVariable,
    ThemeColorVariable,
    ThemeFontSizeVariable,
    ThemeIconSizeVariable,
    ThemeRadiusVariable,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";

interface IEditOptionCard {
    title: string;
    icon: Icons;
    onClick: () => void;
    trackingId?: string;
}

const EditOptionCard = ({ title, icon, onClick, trackingId }: IEditOptionCard) => {
    return (
        <Box
            as="button"
            border={ThemeBorderVariable.XSmall}
            borderColor={ThemeColorVariable.OnBackgroundBorder}
            borderRadius={ThemeRadiusVariable.Medium}
            p={ThemeSpaceVariable.Medium}
            onClick={onClick}
            data-track-click={trackingId}
        >
            <Flex alignItems="center">
                <Box
                    borderRadius="full"
                    bg={ThemeColorVariable.Background}
                    p={ThemeSpaceVariable.Small}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    mr={ThemeSpaceVariable.Medium}
                >
                    <Icon icon={icon} size={ThemeIconSizeVariable.Medium} />
                </Box>
                <Text
                    fontWeight="500"
                    fontSize={ThemeFontSizeVariable.Large}
                    color={ThemeColorVariable.OnBackground}
                >
                    {title}
                </Text>
            </Flex>
        </Box>
    );
};

export default EditOptionCard;
